// eslint-disable

/* Register ScrollTrigger */
gsap.registerPlugin(ScrollTrigger)
ScrollTrigger.config({
	autoRefreshEvents: 'visibilitychange,DOMContentLoaded,load, resize',
})

/* Swiper Initialiser */

var productThumbs = new Swiper('.product__thumbnails', {
	slidesPerView: 3,
	spaceBetween: 20,
	slideToClickedSlide: true,
	initialSlide: 0,
})

const $productCarousel = document.querySelector('.product__carousel');
if ($productCarousel) {

	//const $pagination = $productCarousel.querySelector('.swiper-pagination');
	const scrollBar = $productCarousel.querySelector(".swiper-scrollbar");

	var productCarousel = new Swiper($productCarousel, {
		direction: 'horizontal',
		loop: false,
		slidesPerView: 1.2,
		autoHeight: false,
		speed: 400,
		spaceBetween: 16,
		centeredSlides: false,
		thumbs: {
			swiper: productThumbs,
		},
		breakpoints: {
			1024: {
				slidesPerView: 1,
				spaceBetween: 20,
				centeredSlides: true,
			}
		},
		scrollbar: {
			el: scrollBar,
			draggable: true,
			dragClass: 'swiper-scrollbar-drag',
			dragSize: 'auto',
			snapOnRelease: true,
		}

		/*
		pagination: {
			el: $pagination,
			clickable: true,
		},
		*/
	})
}



  let moreRecipesSwiper = new Swiper(`.more-recipes__recipes`, { 
  direction: 'horizontal',
	loop: false,
	slidesPerView: 1.5,
	autoHeight: false,
	speed: 400,
  spaceBetween: 12,
  navigation: { 
    prevEl: '.more-recipes__button--prev',
    nextEl: '.more-recipes__button--next'
  },
  breakpoints: { 
    1023: { 
      spaceBetween: 20,
      slidesPerView: 4,
    }
  }
  
  })
  let featuredPostsSwiper = new Swiper(`[data-featured-posts-swiper]`, { 
  direction: 'horizontal',
	loop: false,
	slidesPerView: 1.5,
	autoHeight: false,
	speed: 400,
  spaceBetween: 20,
  navigation: { 
    prevEl: '.featured-posts__button--prev',
    nextEl: '.featured-posts__button--next'
  },
  breakpoints: { 
    1023: { 
      spaceBetween: 20,
      slidesPerView: 4,
    }
  }
  
  })


const productCarouselSlides = Array.from(document.querySelectorAll('.product__hero-image'))


document.addEventListener('variantChanged', (evt) => {
	const { variantId } = evt.detail

  productCarouselSlides.forEach((slide) => { 

    if (slide.dataset.variant?.includes(variantId)) { 
      const idx = productCarouselSlides.indexOf(slide)

      productCarousel.slideTo(idx)
    } 

  })

	})

var featuredReviewsCarousel = new Swiper('.featured-reviews__reviews', {
	direction: 'horizontal',
	slidesPerView: 3,
	speed: 600,
	pagination: {
		el: '.swiper-pagination',
	},
	spaceBetween: 30,
})

//Mobile Swipers

const mobileFeaturedProductsCarousels = document.querySelectorAll(
	'.featured-products__inner.mobile'
)

const mobileCollectionProductsCarousels = document.querySelectorAll(
	'.product-card-swiper.mobile'
)

const mobileProductCarousels = [
	...mobileFeaturedProductsCarousels,
	...mobileCollectionProductsCarousels,
]

mobileProductCarousels.forEach((el, i) => {
	el.classList.add(`mobile-featured-products-${i}`)

	const featuredProductsCarousel = new Swiper(
		`.mobile-featured-products-${i}`,
		{
			direction: 'horizontal',
			slidesPerView: 1.25,
			speed: 600,
			spaceBetween: 12,
		}
	)
})

const imageCardsSwiper = Array.from(document.querySelectorAll('[data-image-cards-swiper]'))

imageCardsSwiper.forEach((el, i) => { 
    el.classList.add(`image-cards-swiper-${i}`)
  
       const swiper = new Swiper(
      `.image-cards-swiper-${i}`,
      {
        direction: 'horizontal',
        slidesPerView: 1.5,
        speed: 600,
        spaceBetween: 12,
      }
    )
})



/* Toggle Class (Generic) */
function toggleClass(modalName) {
	var modalActive = document.querySelector(modalName)
	modalActive.classList.toggle('active')
}

/* Change Product Quantity */
function changeQuantity(formId, quantity) {
	var formQ = document.querySelector(formId)

	if (quantity == '+') {
		Number(formQ.value++)
	} else if (quantity == '-' && formQ.value > 1) {
		Number(formQ.value--)
	}
}

const body = document.querySelector('body')

/* Open Cart */
function cartOpen() {
	body.classList.add('js-my-cart-open');
}

/* Details Animator - Product Accordions */
const details = document.querySelectorAll('details');

if (details) {
	details.forEach((targetDetail) => {
		targetDetail.addEventListener('click', function (e) {
			if (targetDetail.hasAttribute('open')) {
				e.preventDefault()
				targetDetail.classList.add('closing')
				setTimeout(() => {
					targetDetail.removeAttribute('open')
					targetDetail.classList.remove('closing')
				}, 390)
			}
		})
	})
}

/* On a product page, clicking "Find out more" or "ingredients & nutritionals" needs to scroll to and open the relevant accordion */
const $productAccordionSection = document.getElementById('product-accordions');
if ($productAccordionSection) {
	
	//Are there anchor links? 
	const $anchorLinksContainer = document.querySelector('.product__anchor-links');
	
	if ($anchorLinksContainer) {
		const $anchorLinks = $anchorLinksContainer.querySelectorAll('.product__anchor-link');
		const $accordions = $productAccordionSection.querySelectorAll('.product__accordion .accordion__item');
		
		if ($anchorLinks && $accordions ) {
			
			//bind click event
			$anchorLinks.forEach(($anchorLink) => {
				$anchorLink.addEventListener("click", (e) => {

					e.preventDefault();

					const targetAccordion = e.currentTarget.dataset.target;
					
					$accordions.forEach(($accordion) => {
						if ($accordion.dataset.accordionType == targetAccordion) {
							if (!$accordion.hasAttribute('open')) {

								$accordion.setAttribute('open', '');

								//Two headers to contend with
								const $headers = document.querySelectorAll('.header');
								let headerHeight = 0;
								if ($headers) {
									$headers.forEach(($header) => {
										const headerRect = $header.getBoundingClientRect();
										if (headerRect.height > headerHeight) {
											headerHeight = headerRect.height;	
										}
									});
								}

								window.scrollTo({top: ($accordion.getBoundingClientRect().top + window.scrollY) - headerHeight - 20,behavior: 'smooth'});
							}
						}
					});
				});
			});
		}
	}
}


const fetchCartData = async () => {
    try {
        const response = await fetch('/cart.js');
        if (!response.ok) throw new Error("Failed to fetch cart data");
        return await response.json();
    } catch (error) {
        console.error("Error fetching cart data:", error);
        return null;
    }
}

const updateCartThreshold = async () =>{
	
	//Determine if cart threshold visual is being used
	const cartThresholdContent = document.querySelector(".cart-modal .cart-modal__hero-threshold-container");

	if(cartThresholdContent){

		//Get the data we need from the container
		const unqualifiedMessage = cartThresholdContent.dataset.unqualifiedMessage;
		const qualifiedMessage = cartThresholdContent.dataset.qualifiedMessage;
		const postageThreshold = cartThresholdContent.dataset.cartThreshold;
		
		if(unqualifiedMessage && qualifiedMessage && postageThreshold){

			const cartThresholdMeterPercentage = cartThresholdContent.querySelector(".cart-modal__hero-threshold-meter .cart-modal__hero-threshold-percentage");	
			const cartThresholdMessage = cartThresholdContent.querySelector('.cart-modal__hero-threshold-message');
			if(cartThresholdMeterPercentage && cartThresholdMessage){

				//Fetch cart data from shopify
				const cartData = await fetchCartData(); // Wait for the fetch to complete
				if (cartData){
		
					//Update the Visual reference of Free Shipping threshold
					let threshold = postageThreshold * 100;

					//Calculate whether customer over the threshold or not
					if(cartData.total_price >= threshold){

						//update meter
						cartThresholdMeterPercentage.style.width = "100%";

						//update message
						cartThresholdMessage.textContent = qualifiedMessage;

					}else{

						console.log("threshold is greater than cart price");

						//Update percentage of meter
						cartThresholdMeterPercentage.style.width = ((cartData.total_price / threshold) * 100) + "%";

						//Update the message about how much is remaining
						const remainingAmount = ((threshold - cartData.total_price) / 100).toFixed(2);
						
						const messageToInsert = unqualifiedMessage.replace('[[replace_value]]', '<span class = "highlight">&pound;' + remainingAmount + '</span>');

						cartThresholdMessage.innerHTML = messageToInsert;
					}		
				}else{
					console.log('failed to fetch cart data');
				}
			}else{
				console.log('unable to find cart threshold meter and/or cart threshold message, cannot update section.');
			}
		}else{
			console.log("dataset values not available on threshold container. Expecting: unqualifiedMessage + qualifiedMessage + cartThreshold");
		}
	}
}


/* Orphan Remove and LSEP Removal */
var nbspSelectors = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'a', 'span']
var nbspWordMin = 10 //Minimum words within parent tag to activate script

// nbspSelectors.forEach(function (selector) {
// 	var nbspElements = document.querySelectorAll(selector)
// 	nbspElements.forEach(function (element) {
// 		element.innerHTML = element.innerHTML.replace(/\u2028/g, '')
// 		element.innerHTML = element.innerHTML.replace(/&#8232;/g, '')
// 		var wordCount = element.innerHTML.split(' ').length
// 		if (wordCount >= nbspWordMin) {
// 			element.innerHTML = element.innerHTML.replace(/ ([^ ]*)$/, '&nbsp;$1')
// 		}
// 	})
// })

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({})

/* Liquid Ajax Cart */

liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
	if (state.requestType == 'add') {
		const form = state.info.initiator
		let btnInner = ''

		const btn = form.querySelector('button[type="submit"]')
		if (btn) {
			btnInner = btn.innerHTML
			btn.innerHTML = 'ADDING'
		}

		subscribeToResult((state) => {
			const btn = form.querySelector('button[type="submit"]')
			if (state.responseData.ok) {
				cartOpen()
			}

			if (btn) {
				setTimeout(() => {
					btn.innerHTML = btnInner
				}, 300)
			}
		})
	}

	//React to all updates of the cart
	subscribeToResult((state) => {
		if (state.responseData.ok) {

			//Update the cart threshold free p&p tracker
			updateCartThreshold();

		}else{
			console.log('An error occurred during Cart update');
			console.log(state.responseData);
		}
	});
})

// Header Animation

const headerLinks = document.querySelectorAll('.header__menu-button')
const submenu = document.querySelector('#headerSubmenu')
const headerBg = document.querySelector('#headerBg')
const searchContainer = document.querySelector('#headerSearchbar')

headerLinks.forEach((link) => {
	link.addEventListener('mouseenter', () => {
		const activeMenuButton = document.querySelector(
			'.header__menu-button-link.active'
		)
		const activeSubMenu = document.querySelector('.header__submenu-item.active')

		if (activeMenuButton) {
			activeMenuButton.classList.remove('active')
		}
		if (activeSubMenu) {
			activeSubMenu.classList.remove('active')
		}

    searchContainer.classList.remove('active')

    triggerSubMenu(link)
  })

  if (link.dataset.hasLinks != null) {
  const submenuItem = link.querySelector('.header__submenu-item')

  submenuItem.addEventListener('mouseleave', (e) => closeSubMenu(link))
  }
})

const closeSubMenu  = (link = false) => { 
  if (link) { 
    const submenuItem = link.querySelector('.header__submenu-item')
    const buttonLink = link.querySelector('.header__menu-button-link')
    buttonLink.classList.remove('active')
    if (submenuItem) { 
      submenuItem.classList.remove('active')
    }
  }
  headerBg.classList.remove('active')
  submenu.classList.remove('active')
  searchContainer.classList.remove('active')
}

const triggerSubMenu  = (link) => { 
  const submenuItem = link.querySelector('.header__submenu-item')
  const buttonLink = link.querySelector('.header__menu-button-link')

  if (link.dataset.hasLinks != null) {
    headerBg.classList.add('active')
    submenu.classList.add('active')
    buttonLink.classList.add('active')
    submenuItem.classList.add('active')
    
  } else { 
    headerBg.classList.remove('active')
    submenu.classList.remove('active')
    buttonLink.classList.remove('active')
    if ( submenuItem ) { 
      submenuItem.classList.remove('active')
    }
    searchContainer.classList.remove('active')

  }
}



headerBg.addEventListener('click', () => { 
  closeSubMenu()

})

function handleSearchClick() {
  const activeMenuButton = document.querySelector(
    '.header__menu-button-link.active'
  )
  const activeSubMenu = document.querySelector('.header__submenu-item.active')
  
  if (activeMenuButton) { 
    activeMenuButton.classList.remove('active')
  }
  
  if (activeSubMenu) { 
    activeSubMenu.classList.remove('active') 
    searchContainer.classList.add('active')
  } else { 
    searchContainer.classList.toggle('active')
  }
  
  submenu.classList.toggle('active')
  headerBg.classList.toggle('active')
}
//Mobile Header

const mobileHeaderBtns = document.querySelectorAll('[data-mobile-nav-btn]')
const mobileHeader = document.querySelector('#mobileHeader')
const childLinkContainers = document.querySelectorAll(
	'.mobile-navigation__child-links-container'
)

const mobileSearchBtn = document.querySelectorAll('[data-mobile-search-btn]')
const mobileSearchCont = document.querySelector('.mobile-search')

mobileHeaderBtns.forEach((btn) => {
	btn.addEventListener('click', () => {

    if (mobileSearchCont && mobileSearchCont.classList.contains('active')) { 
      mobileSearchCont.classList.remove('active')
    }
		if (mobileHeader) {
			mobileHeader.classList.toggle('open')
		}
		setTimeout(() => {
			childLinkContainers.forEach((el) => {
				el.classList.remove('active')
			})
		}, 300)
	})
})

/* Mobile Navigation */

const navigationInner = document.querySelector('.mobile-navigation-inner')
const mobileNavBtns = document.querySelectorAll(
	'.mobile-navigation__link-container'
)

mobileNavBtns.forEach((btn) => {
	btn.addEventListener('click', (e) => {
    e.currentTarget.classList.toggle('active')
		const link = e.currentTarget.dataset.link
		const childLinks = document.querySelector(
			`.mobile-navigation__child-links-container[data-link="${link}"]`
		)
    const currentChild = document.querySelector(
			'.mobile-navigation__child-links-container.active'
		)
    const currentParent = document.querySelector(
			'.mobile-navigation__link-container.active'
		)

    if (currentChild) { 
      if (currentChild != childLinks) {  
        currentChild.classList.remove('active')
      }
    }
    if (currentParent) { 
      if (currentParent != e.currentTarget) {  
        currentParent.classList.remove('active')
      }
    }
		childLinks.classList.toggle('active')
	})
})


//Mobile Search


mobileSearchBtn.forEach((btn) => { 
  btn.addEventListener('click', () => { 
    if (mobileHeader && mobileHeader.classList.contains('open')) { 
      mobileHeader.classList.remove('open')
    }
    mobileSearchCont.classList.toggle('active')
  })
})
// Product Card Atc Forms Open / Close

let productCardAtc = document.querySelectorAll('[data-card-atc]')

function listenersToCards() {
	productCardAtc.forEach((atc) => {
		const card = atc.closest('.product-card')
		const form = card.querySelector('.product-card__atc-form')
		const closeBtn = card.querySelector('.product-card__atc-form-close-btn')
		const quantity = card.querySelector('.product-card__quantity')
		const btns = card.querySelectorAll('.product-card__quantity-btn')
		const optionSelect = card.querySelector('[data-purchase-type-select]')
		const subscriptionSelect = card.querySelector('[data-subsciption-select]')
		const variantSelect = card.querySelector('[data-variant-select')
		const sellingPlanInput = card.querySelector('#sellingPlanSelect')

		const regPrice = card.querySelector('.product-card__normal-price')
		const subPrice = card.querySelector('.product-card__sub-price')

		const selects = form.querySelectorAll(
			'.product-card__option-select-container'
		)

		atc.addEventListener('click', (e) => {
			e.preventDefault()

			form.classList.add('active')
			if (selects) {
				selects.forEach((select) => {
					select.addEventListener('click', (e) => {
						e.preventDefault()
					})
				})
			}
		})

		card.addEventListener('mouseleave', () => {
			form.classList.remove('active')
		})

		btns.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault()
				changeCardQuantity(card, btn.name)
			})
		})

		closeBtn.addEventListener('click', (e) => {
			e.preventDefault()
			form.classList.remove('active')
		})

		quantity.addEventListener('click', (e) => {
			e.preventDefault()
		})

		if (optionSelect) {
			optionSelect.addEventListener('change', (e) => {
				const value = e.target.value

				if (value == 'oneOff') {
					subscriptionSelect.style.display = 'none'
					subPrice.style.display = 'none'
					sellingPlanInput.name = ''
					regPrice.classList.add('product-card__normal-price--regular')
				} else if (value == 'subscription') {
					subscriptionSelect.style.display = 'flex'
					subPrice.style.display = 'block'
					sellingPlanInput.name = 'selling_plan'
					regPrice.classList.remove('product-card__normal-price--regular')
				}
			})
		}

		if (variantSelect) {
			variantSelect.addEventListener('change', (e) => {
				const el = e.target.options[e.target.selectedIndex]
				const elPrice = el.dataset.price
				const elSubPrice = el.dataset.subPrice

				const quantityAmount = quantity.querySelector('input').value

				regPrice.innerHTML = formatMoney(
					regPrice.innerHTML,
					elPrice,
					quantityAmount
				)
				regPrice.dataset.price = elPrice

				if (elSubPrice) {
					subPrice.innerHTML = formatMoney(
						regPrice.innerHTML,
						elSubPrice,
						quantityAmount
					)
					subPrice.dataset.price = elSubPrice
				}
			})
		}
	})
}

listenersToCards()

const footer = document.querySelector('footer')
const stickyAtc = document.querySelector('#stickyAtc')

if (stickyAtc) {
	enterView({
		selector: 'footer',
		enter: function (el) {
			stickyAtc.classList.add('hidden')
		},
		exit: function (el) {
			stickyAtc.classList.remove('hidden')
		},
		offset: -0.2,
	})
}

/* EnterView  */

const reveals = document.querySelectorAll('.reveal')
const stagger = document.querySelectorAll('.stagger')

if (reveals.length > 0) {
	enterView({
		selector: '.reveal',
		enter: (el, i) => {
			el.classList.add('entered')
		},
		exit: (el) => {
			el.classList.remove('entered')
		},
		offset: 0.1,
	})
}

if (stagger.length > 0) {
	stagger.forEach((el) => {
		el.querySelectorAll('.stagger-child').forEach((e, i) => {
			e.style.setProperty('--animation-order', i)
		})
	})
}

//about navigation
const aboutNavigation = document.querySelector('.about-navigation')

if (aboutNavigation) {
	const sections = gsap.utils.toArray('section')

	sections.forEach((section, i) => {
		ScrollTrigger.create({
			trigger: section,
			scroller: 'body',
			start: 'top center',
			end: 'bottom 50%',
			markers: false,
			onToggle: (self) => {
				if (self.trigger.id) {
					const activeNav = aboutNavigation.querySelector(
						`[data-link="${self.trigger.id}"`
					)
					const oldNav = aboutNavigation.querySelector(`.active`)
					if (oldNav) {
						oldNav.classList.remove('active')
					}
					if (activeNav) {
						activeNav.classList.add('active')
					}
				}
			},
		})
	})

	enterView({
		selector: 'footer',
		enter: (el) => {
			aboutNavigation.classList.add('hide')
		},
		exit: (el) => {
			aboutNavigation.classList.remove('hide')
		},
		offset: 0.1,
	})
}

const hideFaqNav = document.querySelector('#hideFaqNav')
const faqNav = document.querySelector('#faqNav')

if (faqNav) {
	if (hideFaqNav) {
		enterView({
			selector: '.featured-products__title',
			enter: () => {
				faqNav.classList.add('hide')
			},
			exit: () => {
				faqNav.classList.remove('hide')
			},
			offset: 0.5,
		})
	} else {
		enterView({
			selector: 'footer',
			enter: () => {
				faqNav.classList.add('hide')
			},
			exit: () => {
				faqNav.classList.remove('hide')
			},
			offset: 0.5,
		})
	}
}

//Map Interactivity

//Subscription Builder

const subscriptionBtns = Array.from(
	document.querySelectorAll('[data-subscribe-button], [href="#pickAndMix"]')
)

subscriptionBtns.forEach((btn) => {
	btn.addEventListener('click', () =>
		body.classList.toggle('subscription-builder-open')
	)

	body.classList.toggle('no-scroll')
})

const perkItems = Array.from(document.querySelectorAll('.perk-item'))

if (perkItems.length > 0) {
	perkItems.forEach((item) => {
		item.addEventListener('mouseenter', (e) => {
			perkItems
				.filter((i) => i != e.currentTarget)
				.forEach((el) => el.classList.add('inactive'))
		})
		item.addEventListener('mouseleave', (e) => {
			perkItems
				.filter((i) => i != e.currentTarget)
				.forEach((el) => el.classList.remove('inactive'))
		})
	})
}

// subscription block

const subscriptionTabs = Array.from(
	document.querySelectorAll('.subscription__tab[data-product]')
)

if (subscriptionTabs.length > 0) {
	subscriptionTabs.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			//tabs
			document
				.querySelector('.subscription__tab.active')
				.classList.remove('active')
			btn.classList.add('active')

			//content

			document
				.querySelector(`.subscription-block.active`)
				.classList.remove('active')
			document
				.querySelector(
					`.subscription-block[data-product="${btn.dataset.product}"]`
				)
				.classList.add('active')
		})
	})
}

function initRecommendedSwiper() {

  const relatedProductSwiper = document.querySelectorAll('[data-related-products-swiper]')
  relatedProductSwiper.forEach((el, i) => {
    el.classList.add(`related-products-swiper-${i}`)
  
    const relatedProductsSwipe = new Swiper(
      `.related-products-swiper-${i}`,
      {
        direction: 'horizontal',
        slidesPerView: 1.5,
        speed: 600,
        spaceBetween: 12,
        navigation: { 
          nextEl: '.featured-collection__button--next',
          prevEl: '.featured-collection__button--prev'
        },
        breakpoints: { 
          1023: { 
            spaceBetween: 20,
            slidesPerView: 4,
          }
        }
      }
    )
  })
}

//Logo Scroller pause on hover

const logoScrollers = document.querySelectorAll('.logos-container')
if (logoScrollers.length > 0) {
	logoScrollers.forEach((el) => {
		el.addEventListener('mouseover', () => {
			logoScrollers.forEach((l) => l.classList.add('paused'))
		})
		el.addEventListener('mouseleave', () => {
			logoScrollers.forEach((l) => l.classList.remove('paused'))
		})
	})
}
//ll video

/* enterview */
/* Load video on enter */

const llVideos = document.querySelectorAll('.video-ll')

if (llVideos.length > 0) {
	enterView({
		selector: '.video-ll',
		enter: function (el) {
			el.load()
			el.play()
		},
		offset: 0.1,
	})
}

function removePickMix(e) {
	const { cart } = liquidAjaxCart.getCartState()
	e.preventDefault()

	const pickMixItems = cart.items.filter((item) =>
		item.title.includes('1x')
	)

	const req = {}

	pickMixItems.forEach((item) => {
		req[item.id] = 0
	})

	liquidAjaxCart.cartRequestUpdate({
		updates: req,
	})
}

// Recipe Feedback

const feedbackModal = document.querySelector('#recipeFeedbackModal')
const feedbackModalTriggers = document.querySelectorAll(
	'[data-feedback-trigger]'
)

if (feedbackModal) {
	const feedbackForm = feedbackModal.querySelector('form')

	feedbackModalTriggers.forEach((trigger) => {
		trigger.addEventListener('click', () => {
			feedbackModal.classList.toggle('active')
		})
	})

	feedbackForm.addEventListener('submit', (evt) => {
		const form = feedbackForm
		const submitBtn = form.querySelector('button')
		evt.preventDefault()

		let formData = new FormData(form)
		const formDataAsJSON = {}
		formData.forEach((value, key) => (formDataAsJSON[key] = value))

		const options = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify(formDataAsJSON),
		}

		let message = form.querySelector('template')
		if (message) {
			message = message.content.cloneNode(true)
			form.innerHTML = ''
			form.appendChild(message)
		}

		submitBtn.innerHTML = 'Submitting'
		fetch(form.action, options)
			.then(() => {
				submitBtn.innerHTML = 'Thanks for your feedback'
				setTimeout(() => feedbackModal.classList.toggle('active'), 1000)
			})
			.then(() => {
				setTimeout(() => {
					form.reset()
					submitBtn.innerHTML = 'Send →'
				}, 2000)
			})
			.catch((error) => {
				console.error(error)
			})
	})
}

// Dietary Key Modal

const ditaryKeyModal = document.querySelector('#dietaryKeyModal')
const ditaryKeyTriggers = document.querySelectorAll(
	'[data-dietary-key-trigger]'
)

ditaryKeyTriggers.forEach((trigger) => {
  trigger.addEventListener('click', () => {
    ditaryKeyModal.classList.toggle('active')
  })
})

//Shop All Products Page - detect when menu is sticky / not sticky and adjust padding accordingly
const $shopAllPage = document.querySelector('.section__shop-all-products');
if ($shopAllPage) {
	const $anchorList = $shopAllPage.querySelector('.shop-all__anchor-list');
	if ($anchorList) {
		document.addEventListener("DOMContentLoaded", (event) => {
			window.addEventListener("scroll", () => {

				if (window.innerWidth > 1023) {

					if (getComputedStyle($anchorList).top == $anchorList.getBoundingClientRect().top+'px') {
						$anchorList.style.paddingTop = 60 + 'px';
					} else {
						$anchorList.style.paddingTop = 32 + 'px';
					}
				} else {
					console.log('failing');
				}
			});
		});
	}
}

//Product Page Link Recipes section
const $linkedRecipesSection = document.querySelector('.section-product-linked-recipe');
if ($linkedRecipesSection) {
	const $linkedRecipeTabs = $linkedRecipesSection.querySelectorAll('.product-linked-recipe__tabs .product-linked-recipe__tab');

	const $linkedRecipeIngredientsContent = $linkedRecipesSection.querySelector(".product-linked-recipe__ingredients");
	const $linkedRecipeDirectionContent = $linkedRecipesSection.querySelector(".product-linked-recipe__directions");

	if ($linkedRecipeTabs && $linkedRecipeIngredientsContent && $linkedRecipeDirectionContent) {

		const viewMoreBtn = $linkedRecipeIngredientsContent.querySelector('.ingredients-view-more');

		$linkedRecipeTabs.forEach(($linkedRecipeTab) => {
			$linkedRecipeTab.addEventListener("click", () => {
				if (!$linkedRecipeTab.classList.contains('active-tab')) {

					if ($linkedRecipeIngredientsContent.classList.contains("mobile-height-restriction")) {
						$linkedRecipeIngredientsContent.classList.remove("mobile-height-restriction");

						if (viewMoreBtn) {
							viewMoreBtn.classList.add("hidden");
						}
					}

					if ($linkedRecipeTab.dataset.target == 'directions') {

						$linkedRecipeIngredientsContent.classList.add('hidden');
						$linkedRecipeDirectionContent.classList.remove('hidden');

					} else if($linkedRecipeTab.dataset.target == 'ingredients'){
						$linkedRecipeIngredientsContent.classList.remove('hidden');
						$linkedRecipeDirectionContent.classList.add('hidden');

					} else {
						console.log('Unknown target - system not sure which content to show');	
					}
					
					$linkedRecipeTabs.forEach(($linkedTab) => {
						$linkedTab.classList.toggle('active-tab');
					});
				}
			});
		});

		//View more functionality on a mobile
		if (viewMoreBtn) {
			viewMoreBtn.addEventListener("click", () => {
				$linkedRecipeIngredientsContent.classList.remove("mobile-height-restriction");
				viewMoreBtn.classList.add("hidden");
			});
		}
	}
}